function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.657 14.578L12 8.922l-5.657 5.656 1.06 1.061L12 11.043l4.596 4.596 1.06-1.061z"
});

function SvgExpandLessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _ref);
}

export default SvgExpandLessIcon;